<template>

  <div class="login-container">
    <div class="login-content">
      <div class="login login-1" :class="getPartner ? '' : 'login-1-bg'">
        <img
            v-if="getPartner"
            :src="getPartner.logo_url"
            style="padding: 12px;"
        >
        <img
            v-else
            src="@/assets/images/logo-brobot-ic.png"
        >
      </div>
      <div class="login login-2">
        <slot/>
        <div v-if="!getPartner" class="d-flex flex-column justify-content-end text-center pt-5">
          <p>Brobot © {{ year() }} </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import GetPartner from '@/mixins/GetPartner'

  export default {
    methods: {
      year() {
        return new Date().getUTCFullYear()
      },
    },
    name: 'Form',
    mixins: [GetPartner]
  }
</script>

<style scoped>

.login{
  width: 100%;
  height: 100%;
}

.login-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: var(--background-color);
  /*margin-top: 5%;*/
  /*margin-bottom: 5%;*/
}

.login-content{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 558px;
  width: 910px;
  margin-top: 5%;
  margin-bottom: 5%;
}

.login-1{
  padding: 5%;
  opacity: 0.9;
  box-shadow: 0px 4px 50px rgba(153, 153, 153, 0.25);
  background-color: var(--login-color);
  border-radius: 10px 0px 0px 10px;
  position: relative;
}

.login-1-bg {
  background: linear-gradient(269.22deg, #003162 0%, #69D3F4 125.09%);
}

.login-2{
  padding: 5%;
  background: var(--card-bg);
  color: var(--primary-text-color);
  box-shadow: 0px 4px 50px var(--shadow-color);
  border-radius: 0px 10px 10px 0px;
}

@media screen and (max-width: 700px) {
  .login-content {
    flex-direction: column;
    width: 100%;
    height: 100vh;
    margin: 0;
    padding: 0;
  }
  .login-1{
    border-radius: 0px 0px 0px 0px;
    height: 30%;
    margin: 0;
  }
  .login-2{
    border-radius: 0px 0px 10px 0px;
    margin: 0;
  }
  #sign-in{
    order: 1;
  }
  #sign-up{
    order: 2;
  }
}

span{
  opacity: 0.65;
}

.input-group-text{
  font-color: white;
}

img {
  max-height: 100%;
  max-width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}

</style>
